/**
 * What "archived" means for the client workspace.
 *
 * Deleting a client that has onboarding data archives the row rather than destroying it (CR.11), and
 * nothing downstream used to re-check the flag. The overview does not filter archived clients out, so
 * the workspace opened an archived client's own URL — `/company/{guid}/details` — with the sidebar
 * live and every field editable, while the legacy archive route `/company/archived/{id}` had been
 * locked down from the start. Anyone holding the URL could still edit a client they had deleted.
 */

/** Whether the open client has been archived. */
export const isClientArchived = (
  overview: { isArchived?: boolean | null } | null | undefined,
): boolean => Boolean(overview?.isArchived);

/**
 * The workspace sections an archived client cannot open, because every one of them writes.
 *
 * Overview, Details and Activity stay reachable: an archived client is kept in order to be read, and
 * those three are read-only once the Overview's action cards are withheld. Everything listed here
 * owns a save, an add or a delete, so locking the way in is a guarantee rather than an audit of every
 * control inside — and a control added to one of them later cannot quietly reopen the hole.
 */
export const ARCHIVED_CLIENT_LOCKED_SECTIONS: readonly string[] = [
  "sla",
  "actions",
  "sale-deals",
  "company-contacts",
  "company-offices",
  "comments",
  "imperans-link",
  "revenue",
  "documents",
  "details",
];
